import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getMyVaultPath = () => urlHelper('/my-vault');
